import React from "react";
import {
  Link,
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as coupleAction from '../action/coupleAction';


//Material-ui
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
//Part
import PartUserMainImg from './PartUserMainImg';
import PartUserName from './PartUserName';
//Dialog
import DialogConfirm from './DialogConfirm';
//Icon

class Comp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      coupleRequestDelDialog: false,
    }
  }


  _coupleRequestDel() {
    this.props.coupleRequestDel();
  }

	render() {

    if (this.props.notification.coupleRequest) {
      let value = this.props.notification.coupleRequest;
      return (
  			<div className='couple_block'>
          <Box boxShadow={2} style={{background:'#FFF'}} className='round12'>
            <div align='center' style={{padding:'10px'}}>
              <h2>カップリングの申込中</h2>
              <div>申込日: {value.couple_datetime}</div>
              <div style={{display:'flex',flexDirection:'row',justifyContent:'center', alignItems:'center', padding:'10px'}}>
                <Link to={{ pathname: '/partner/' + value.userdata_id_code}}>
                  <PartUserMainImg
                    mainImg={value.userdata_mainImg}
                    width={'50px'}
                    height={'50px'}
                    radius={'50%'}
                  />
                </Link>
                &nbsp;
                <Link to={{ pathname: '/partner/' + value.userdata_id_code}}>
                  <PartUserName
                    data={{
                      name: value.userdata_name,
                      sex: value.userdata_sex,
                      size: '1.2em',
                    }}
                  />
                </Link>
              </div>
              <div>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={ () => this.setState({coupleRequestDelDialog: true}) }
                >
                  カップリングの申込を停止する
                </Button>
              </div>
              <DialogConfirm
                open={ this.state.coupleRequestDelDialog }
                title={'カップリングの申請停止'}
                content={'カップリングの申請を停止してもいいですか？'}
                apply={ () => {
                  this._coupleRequestDel();
                  this.setState({coupleRequestDelDialog: false});
                } }
                close={ () => this.setState({coupleRequestDelDialog: false}) }
              />
            </div>
          </Box>
        </div>
      )
    }
    else {
      return null;
    }
	}
}

const mapStateToProps = (state) => {
	return {
    notification: state.notification,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...coupleAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
